<template>
  <div class="items-container">
    <h1>Items</h1>

    <!-- Filters -->
    <div class="filters">
      <input type="text" v-model="filters.item_no" placeholder="Search by Item No..." class="search-input"/>
      <input type="text" v-model="filters.item_name" placeholder="Search by Item Name..." class="search-input"/>
      <input type="text" v-model="filters.description" placeholder="Search by Description..." class="search-input"/>
    </div>

    <button @click="openAddPopup()" class="add-button">Add Item</button>

   

    <!-- Items Table -->
    <div class="table-container">
      <table class="items-table">
        <thead>
          <tr>
            <th>Item No</th>
            <th>Item Name</th>
            <th>Description</th>
            <th>Category</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in sortedItems" :key="item.item_no">
            <td>{{ item.item_no }}</td>
            <td>{{ item.item_name }}</td>
            <td>{{ item.description || 'N/A' }}</td>
            <td>{{ item.category_name || 'N/A' }}</td>
            <td class="action-buttons">
              <button @click="openEditPopup(item)" class="edit-button">Edit</button>
              <button @click="confirmDelete(item)" class="delete-button">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    

<!-- Add Item Popup -->
<div v-if="showPopup" class="popup-container">
  <div class="popup">
    <h2>Add Item</h2>
    <form @submit.prevent="submitItem">
      
      <!-- Auto-filled Item No (Disabled) -->
      <label>Item No:
        <input type="text" v-model="currentItem.item_no" disabled required />
      </label>

      <!-- Free Text Item Name -->
      <label>Item Name:
        <input type="text" v-model="currentItem.item_name" required />
      </label>

      <!-- Free Text Description -->
      <label>Description:
        <input type="text" v-model="currentItem.description" />
      </label>

      <!-- Category Dropdown -->
      <label>Category:
        <select v-model="currentItem.category_id" required>
          <option value="" disabled>Select a category</option>
          <option v-for="category in categories" :key="category.category_id" :value="category.category_id">
            {{ category.category_name }}
          </option>
        </select>
      </label>

      <div class="popup-buttons">
        <button type="submit" class="save-button">Save</button>
        <button type="button" @click="showPopup = false" class="cancel-button">Cancel</button>
      </div>
    </form>
  </div>
</div>

<!-- Edit Item Popup -->
<div v-if="showEditPopup" class="popup-container">
  <div class="popup">
    <h2>Edit Item</h2>
    <form @submit.prevent="submitEditItem">
      
      <!-- Item No (Cannot be changed) -->
      <label>Item No:
        <input type="text" v-model="currentItem.item_no" disabled required />
      </label>

      <!-- Editable Item Name -->
      <label>Item Name:
        <input type="text" v-model="currentItem.item_name" required />
      </label>

      <!-- Editable Description -->
      <label>Description:
        <input type="text" v-model="currentItem.description" />
      </label>

      <!-- Category Dropdown in Edit Popup -->
      <label>Category:
        <select v-model="currentItem.category_id" required>
          <option value="" disabled>Select a category</option>
          <option v-for="category in categories" :key="category.category_id" :value="category.category_id">
            {{ category.category_name }}
          </option>
        </select>
      </label>

      <div class="popup-buttons">
        <button type="submit" class="save-button">Save</button>
        <button type="button" @click="showEditPopup = false" class="cancel-button">Cancel</button>
      </div>
    </form>
  </div>
</div>



  </div>
</template>

<script>
import api from '@/services/api';

export default {
  data() {
    return {
      items: [],
      showPopup: false,
      showEditPopup: false,
      editing: false,
      filters: { item_no: '', item_name: '', description: '' },
      currentItem: { item_no: '', item_name: '', description: '', category_id: '' },
      categories: [], // ✅ Holds category list for the dropdown      
      selectedCategories: []
    };
      
  },


  computed: {

    sortedItems() {
  return this.filteredItems.slice().sort((a, b) =>
    a.item_name.localeCompare(b.item_name)
  );
},


    filteredItems() {
      return this.items.filter(item =>
        (!this.filters.item_no || item.item_no.includes(this.filters.item_no)) &&
        (!this.filters.item_name || item.item_name.toLowerCase().includes(this.filters.item_name.toLowerCase())) &&
        (!this.filters.description || item.description?.toLowerCase().includes(this.filters.description.toLowerCase()))
      );
    }
  },
  
  methods: {
    async fetchItems() {
    try {
        console.log("🔄 Fetching items...");

        const response = await api.get('/items');
        this.items = response.data.map(item => ({
            item_no: item.item_no,
            item_name: item.item_name,
            description: item.description || "N/A",
            category_name: item.category_name || "Unknown" // ✅ Ensures category is set
        }));

        console.log("📥 Items loaded:", this.items);
    } catch (error) {
        console.error("❌ Error fetching items:", error);
    }
},

 

    async submitItem() {
    try {
        if (!this.currentItem.item_name || !this.currentItem.category_id) {
            alert("❌ Item Name and Category are required!");
            return;
        }

        console.log("📤 Submitting new item:", this.currentItem);

        const response = await api.post('/items', {
            item_no: this.currentItem.item_no,
            item_name: this.currentItem.item_name,
            description: this.currentItem.description,
            category_id: this.currentItem.category_id
        });

        console.log("✅ Item successfully added:", response.data);
        this.showPopup = false;
        await this.fetchItems(); // Refresh item list after addition

    } catch (error) {
        console.error("❌ Error adding item:", error);
        alert("⚠️ Failed to add item. Please check the logs.");
    }
},


    async openAddPopup() {
    console.log("➕ Add Item button clicked!"); // ✅ Debugging Log

    try {
        console.log("🔄 Fetching next item number & categories...");
        const response = await api.get('/items/new'); // Use Axios-style API call

        console.log("📥 Received data:", response.data); // ✅ Debugging log

        this.currentItem = {
            item_no: response.data.next_item_no, // Auto-incremented item_no
            item_name: '',
            description: '',
            category_id: null
        };

        this.categories = JSON.parse(JSON.stringify(response.data.categories)); // Ensure Vue updates

        this.showPopup = true;

        // 🟢 Set focus on the first input field
        this.$nextTick(() => {
            const firstInput = document.querySelector(".popup input");
            if (firstInput) {
                console.log("🎯 Focusing on:", firstInput);
                firstInput.focus();
            } else {
                console.warn("⚠️ No input field found to focus!");
            }
        });

    } catch (error) {
        console.error("❌ Error loading Add Item popup:", error);
    }
},


async openEditPopup(item) {
    console.log("✏️ Editing item:", item.item_no); // ✅ Debugging log

    try {
        // ✅ Fetch categories if they haven't been loaded
        if (this.categories.length === 0) {
            const response = await api.get('/items/new'); // Uses existing route to fetch categories
            this.categories = response.data.categories;
        }

        // ✅ Ensure existing category_id is set
        this.currentItem = {
            item_no: item.item_no,
            item_name: item.item_name,
            description: item.description,
            category_id: item.category_id // ✅ Ensures dropdown is pre-filled
        };

        this.showEditPopup = true;
    } catch (error) {
        console.error("❌ Error fetching categories for edit popup:", error);
    }
},

    async submitEditItem() {
        try {
            console.log("📤 Submitting item update:", this.currentItem);

            const response = await api.put(`/items/${this.currentItem.item_no}`, {
                item_name: this.currentItem.item_name,
                description: this.currentItem.description,
                category_id: this.currentItem.category_id
            });

            console.log("✅ Item updated successfully:", response.data);
            this.showEditPopup = false;

            // Refresh item list after update
            await this.fetchItems(); 
        } catch (error) {
            console.error("❌ Error updating item:", error);
        }
    },
    
    async confirmDelete(item) {
  console.log("🗑 Attempting to delete item:", item.item_no);

  try {
    await api.delete(`/items/${item.item_no}`); // ✅ No unused variable
    alert("✅ Item deleted successfully!");
    this.fetchItems(); // ✅ Refresh list
  } catch (error) {
    console.error("❌ Error deleting item:", error);

    // Extract meaningful error message
    const errorMessage = error.response?.data?.error || "An unknown error occurred.";

    // Show user-friendly alert
    alert(`❌ Cannot delete item: ${errorMessage}`);
  }
}

  },

  async mounted() {
    this.fetchItems();      // Fetches items already in the local database
    this.fetchCategories(); // Fetches categories from backend
  },
};
</script>

<style scoped>
/* General Container */
.items-container {
  padding: 20px;
  font-family: "Poppins", sans-serif !important;
  background: #9cd0f2; /* Light grey-blue */
  border-radius: 10px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.table-container {
  background: #eef4fb;
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

/* Filters & Inputs */
.filters {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}

.search-input {
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #b0c4de;
  background: #e6eef3;
}

/* Buttons */
.add-button, .save-button, .cancel-button, .edit-button, .delete-button {
  padding: 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  min-width: 90px;
  text-align: center;
  font-weight: bold;
}

/* Button styles */
.add-button {
  background-color: #288671; /* Deep green */
  color: white;
  margin-right: 10px
}

.add-button:hover {
  background-color: #237a4b; /* Darker green */
}

.save-button {
  background-color: #327ba8; /* Deep blue */
  color: white;
}

.save-button:hover {
  background-color: #286c98; /* Darker blue */
}

.cancel-button {
  background-color: #4f6773; /* Muted blue-grey */
  color: white;
}

.cancel-button:hover {
  background-color: #3a4a5e; /* Darker blue-grey */
}

.edit-button {
  background-color: #3a4a5e; /* Blue-grey */
  color: white;
}

.edit-button:hover {
  background-color: #2a3a4a; /* Darker blue-grey */
}

.delete-button {
  background-color: #9f3207; /* Deep red */
  color: white;
  margin-left: 10px;
}

.delete-button:hover {
  background-color: #1f2a35; /* Darker red */
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
}

/* Tables */
.items-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  border-radius: 10px;
  overflow: hidden;
}

.items-table thead tr {
  position: sticky;
  top: 0;
  background: #f4f7f9;
  z-index: 999;
}

.items-table th {
  border: 1px solid #83a7cb;
  padding: 8px;
  text-align: center;
  background: #e6eef3;
}

.items-table th, .items-table td {
  border: 1px solid #83a7cb;
  padding: 8px;
  text-align: center;
}

.items-table tr:hover {
  background-color: #e0f2f1;
}

/* Popup styles */
.popup-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 60vw;
  max-width: 800px;
  height: 80vh;
  max-height: 700px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  z-index: 1001;
}

.popup-buttons {
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}

.popup label {
  display: block;
  text-align: left;
  margin-bottom: 8px;
}

.popup input {
  width: 100%;
  padding: 6px;
  margin-bottom: 10px;
  border: 1px solid #b0c4de;
  border-radius: 5px;
  background: #e6eef3;
}

/* Make table scrollable inside the popup */
.table-wrapper {
  max-height: 300px;
  overflow-y: auto;
}

/* Overlay */
.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 48, 77, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  pointer-events: none;
}

.popup-overlay .popup {
  pointer-events: auto;
}

/* Header Layout */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

/* Download Button */
.download-button {
  background-color: #327ba8; /* Deep blue, matching save-button */
  color: white;
  padding: 10px 16px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-weight: bold;
  margin-left: 50px
}

.download-button:hover {
  background-color: #286c98; /* Darker blue */
}

/* Popup Container */
.download-popup-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

/* Popup Box */
.download-popup {
  background: white;
  padding: 20px;
  border-radius: 10px;
  width: 50vw;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3);
  z-index: 1001;
}

/* Category Checkboxes */
.category-checkbox-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 8px;
  width: 100%;
  justify-content: flex-start;
}

.category-checkbox-container input {
  transform: scale(1.2); /* Slightly larger checkboxes */
}

/* Popup Buttons */
.download-popup-buttons {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-top: 15px;
}

.download-confirm-button {
  background-color: #288671; /* Deep green, matching add-button */
  color: white;
  padding: 10px 16px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-weight: bold;
}

.download-confirm-button:hover {
  background-color: #237a4b; /* Darker green */
}

.download-cancel-button {
  background-color: #4f6773; /* Muted blue-grey */
  color: white;
  padding: 10px 16px;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  font-weight: bold;
}

.download-cancel-button:hover {
  background-color: #3a4a5e; /* Darker blue-grey */
}

</style>
